import Vue from 'vue'
import axios from '@/api/axios.js'
import { Decimal } from 'decimal.js'

export default {
	async sha256(context, message) {
		// encode as UTF-8
		const msgBuffer = new TextEncoder().encode(message)

		// hash the message
		const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)

		// convert ArrayBuffer to Array
		const hashArray = Array.from(new Uint8Array(hashBuffer))

		// convert bytes to hex string                  
		const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

		return hashHex
	},

	setContracts({ dispatch, commit }) {
		commit('changeSetContractsApiStatus_mut', 'loading')

		return new Promise((resolve) => {
			axios.get('/demo-abx/trade-ticket/contract')
				.then((response) => {
					const responseData = response.data.data
					commit('setContracts_mut', responseData)

					commit('changeSetContractsApiStatus_mut', 'success')
					return resolve()
				}).catch(() => {
					setTimeout(() => {
						commit('changeSetContractsApiStatus_mut', 'error')
						return dispatch('setContracts')
					}, 5000)
				})

		})
	},

	setProducts({ dispatch, commit }) {
		commit('changeSetProductsApiStatus_mut', 'loading')

		return new Promise((resolve) => {
			axios.get('/demo-abx/trade-ticket/product')
				.then((response) => {
					const responseData = response.data.data
					commit('setProducts_mut', responseData)

					commit('changeSetProductsApiStatus_mut', 'success')
					return resolve()
				}).catch(() => {
					setTimeout(() => {
						commit('changeSetProductsApiStatus_mut', 'error')
						return dispatch('setProducts')
					}, 5000)
				})

		})
	},

	// setProfile({ commit }) {
	// 	return new Promise((resolve) => {
	// 		axios.get('/v2/profile')
	// 		.then((response) => {
	// 			const responseData = response.data.data
	// 			localStorage.setItem('profile', JSON.stringify(responseData))
	// 			commit('setProfile_mut', responseData)

	// 			return resolve()
	// 		})
	// 	})
	// },

	setAccountInformation({ dispatch, commit, state }) {
		commit('changeSetAccountInformationApiStatus_mut', 'loading')

		return new Promise((resolve) => {
			axios.get('/demo-abx/account/detailAccount?accountId=' + state.demoAccountId)
				.then((response) => {
					const responseData = response.data.data
					commit('setAccountInformation_mut', responseData)

					commit('changeSetAccountInformationApiStatus_mut', 'success')
					return resolve()
				}).catch(() => {
					setTimeout(() => {
						commit('changeSetAccountInformationApiStatus_mut', 'error')
						return dispatch('setAccountInformation')
					}, 5000)
				})

		})
	},

	setDepths({ commit }) {
		commit('changeSetDepthsApiStatus_mut', 'loading')

		return new Promise((resolve, reject) => {
			axios.get('/demo-abx/trade-ticket/depth')
				.then((response) => {
					const responseData = response.data.data
					commit('setDepths_mut', responseData)

					commit('changeSetDepthsApiStatus_mut', 'success')

					return resolve()
				}).catch(() => {
					commit('changeSetDepthsApiStatus_mut', 'error')

					return reject()
				})
		})
	},

	setStreamingRate({ commit, state }) {
		commit('changeSetStreamingRateApiStatus_mut', 'loading')

		return new Promise((resolve) => {
			state.getStreamingRate_apiStatus = 'loading'
			axios.get('/demo-abx/rate')
				.then((response) => {
					const responseData = response.data.data
					commit('setStreamingRate_mut', responseData)

					commit('changeSetStreamingRateApiStatus_mut', 'success')
					return resolve()
				}).catch(error => {
					commit('changeSetStreamingRateApiStatus_mut', 'error')
					console.error('setStreamingRate', error)
				})
		})
	},

	setBalances({ dispatch, commit, state, getters }) {
		commit('changeSetBalanceApiStatus_mut', 'loading')

		return new Promise((resolve) => {
			axios.get('/demo-abx/account/balanceHistory?marketplaceId=1&accountId=' + state.demoAccountId
			).then((response) => {

				const responseData = response.data.data.data[0]

				const balances = {
					balanceIdr: Decimal.mul(responseData.attributes.total, getters.getStreamingRate.streamBuy).toDecimalPlaces(2).toNumber(),
					balanceUsd: new Decimal(responseData.attributes.total).toDecimalPlaces(2).toNumber(),
					availableTradeBalanceIdr: Decimal.mul(responseData.attributes.total, getters.getStreamingRate.streamBuy).toDecimalPlaces(2).toNumber(),
					availableTradeBalanceUsd: new Decimal(responseData.attributes.total).toDecimalPlaces(2).toNumber(),
					accountBalance: new Decimal(responseData.attributes.total).toDecimalPlaces(2).toNumber(),
					reservedBalance: 0
				}

				commit('setBalances_mut', balances)
				commit('changeSetBalanceApiStatus_mut', 'success')
				return resolve()
			}).catch(() => {
				setTimeout(() => {
					commit('changeSetBalanceApiStatus_mut', 'error')
					return dispatch('setBalances')
				}, 5000)
			})
		})
	},

	setGoldBalances({ dispatch, commit, state }) {
		commit('changeSetGoldBalancesApiStatus_mut', 'loading')

		return new Promise((resolve) => {
			axios.post('/v2/igx/gold_balance', {
				user_id: state.userId
			}).then((response) => {
				const responseData = response.data.data.body
				commit('setGoldBalances_mut', responseData)

				commit('changeSetGoldBalancesApiStatus_mut', 'success')
				return resolve()
			}).catch(() => {
				setTimeout(() => {
					commit('changeSetGoldBalancesApiStatus_mut', 'error')
					return dispatch('setGoldBalances')
				}, 5000)
			})
		})
	},

	setGolds({ commit, state, getters }) {
		return new Promise((resolve) => {
			let depths = JSON.parse(JSON.stringify(state.depths))

			if (!depths) {
				commit('setGold_mut', {})
				return
			}

			//switch buy and sell value in depths
			let temp = []
			for (let prop in depths) {
				temp = depths[prop].buy
				depths[prop].buy = depths[prop].sell
				depths[prop].sell = temp
			}

			let golds = {}

			for (const contractId in depths) {
				let sellPrice = new Decimal(-1)
				let buyPrice = new Decimal(-1)

				const depth = depths[contractId]
				const contractConfig = getters.getContractConfigs(contractId)

				//Multiply with weightCorrection if there is any contract that need to be shown differently from the original weight :)
				for (let i = depth.buy.length - 1; i >= 0; i--) {
					depths[contractId].buy[i].price = Number(Decimal.mul(depths[contractId].buy[i].price, contractConfig.weightCorrection))
					depths[contractId].buy[i].quantity = Number(Decimal.div(depths[contractId].buy[i].quantity, contractConfig.weightCorrection).toFixed(contractConfig.depthQuantityDecimalPlace, Decimal.ROUND_DOWN))
				}
				for (let i = depth.sell.length - 1; i >= 0; i--) {
					depths[contractId].sell[i].price = Number(Decimal.mul(depths[contractId].sell[i].price, contractConfig.weightCorrection))
					depths[contractId].sell[i].quantity = Number(Decimal.div(depths[contractId].sell[i].quantity, contractConfig.weightCorrection).toFixed(contractConfig.depthQuantityDecimalPlace, Decimal.ROUND_DOWN))
				}

				for (let i = depth.buy.length - 1; i >= 0; i--) {
					let buyProp = depth.buy[i]
					if (i == depth.buy.length - 1) { //iniltialize buyPrice
						buyPrice = new Decimal(buyProp.price)
					}
					if (buyPrice.greaterThanOrEqualTo(buyProp.price)) {
						buyPrice = new Decimal(buyProp.price)
					}
				}
				for (let i = depth.sell.length - 1; i >= 0; i--) {
					let sellProp = depth.sell[i]
					if (i == depth.sell.length - 1) { //iniltialize sellPrice
						sellPrice = new Decimal(sellProp.price)
					}
					if (sellPrice.lessThanOrEqualTo(sellProp.price)) {
						sellPrice = new Decimal(sellProp.price)
					}
				}
				// if buy price is not found in depth, then it the same as sell price. Vice versa.
				if (buyPrice.lessThan(0)) {
					buyPrice = sellPrice
				}
				if (sellPrice.lessThan(0)) {
					sellPrice = buyPrice
				}

				let contractPriceBuy = buyPrice
				let contractPriceSell = sellPrice

				buyPrice = buyPrice.dividedBy(contractConfig.weightMultiplication)
				sellPrice = sellPrice.dividedBy(contractConfig.weightMultiplication)

				golds[contractId] = {
					contractId: contractId,
					contractPriceBuy: Number(contractPriceBuy),
					contractPriceSell: Number(contractPriceSell),
					sell: Number(sellPrice),
					buy: Number(buyPrice),
				}

			}
			commit('setGold_mut', golds)

			return resolve()
		})
	},

	setOhlc({ commit, state, getters }) {
		return new Promise(async (resolve) => {
			const depths = state.depths

			let ohlc = {}
			for (const contractId in depths) {
				const contractConfig = getters.getContractConfigs(contractId)

				const responseOhlc = await axios.get('/v2.1/igx/ohlc/' + contractId)

				const data = responseOhlc.data.data.body[0]
				let openPrice = (data.open[0] >= data.open[1]) ? data.open[0] : data.open[1]
				let highPrice = (data.high[0] >= data.high[1]) ? data.high[0] : data.high[1]
				let lowPrice = (data.low[0] >= data.low[1]) ? data.low[0] : data.low[1]
				let closePrice = (data.close[0] >= data.close[1]) ? data.close[0] : data.close[1]

				let change = Decimal.sub(closePrice, openPrice).dividedBy(openPrice).times(100)
				highPrice = Decimal.div(highPrice, Decimal.div(contractConfig.weightInGram, contractConfig.weightCorrection)).toFixed(2)
				lowPrice = Decimal.div(lowPrice, Decimal.div(contractConfig.weightInGram, contractConfig.weightCorrection)).toFixed(2)

				ohlc[contractId] = {
					low: Number(lowPrice),
					high: Number(highPrice),
					change: Number(change.toFixed(2)),
					caretDirection: 'down',
					percentage: 0.0,
				}
			}

			commit('setGold_mut', ohlc)
			return resolve()
		})
	},

	destroyToken(context) {
		if (context.getters.loggedIn) {
			context.commit('DESTROY_TOKEN')
		}
	},
	destroyUser(context) {
		context.commit('DESTROY_USER')
	},

	async refreshToken(context) {
		context.state.apiStatusRefreshToken = 'loading'
		try {
			const response = await axios.post('/v2/user/refresh_token',
				{
					user_id: context.state.userId
				}
			)

			context.state.apiStatusRefreshToken = 'idle'

			const newToken = response.data.data.token
			axios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken

			localStorage.setItem('token', newToken)
			context.commit('SET_TOKEN', newToken)

			localStorage.setItem('refreshTokenTime', Date.now() + context.state.refreshTokenTimeState)
		} catch {
			context.state.apiStatusRefreshToken = 'error'
		}
	},

	getGeolocation({ commit }) {
		commit('AUTH_REQUEST')

		return new Promise((resolve, reject) => {
			fetch('https://asia-southeast2-jfx-prod.cloudfunctions.net/get-user-access-location')
		  .then(result => result.json())
		  .then((output) => {
				const geolocation = {
					...output,
					latitude: output.cityLatLong.split(',')[0],
					longitude: output.cityLatLong.split(',')[1]
				}

					localStorage.setItem('geolocation', JSON.stringify(geolocation))
					commit('SET_GEOLOCATION', geolocation)

					resolve(geolocation)
				})
				.catch(() => {
					reject()
				})
		})
	},

	checkFormatAuth(context, user) {
		console.log(context)
		return new Promise((resolve, reject) => {
			const emailRegex = /^\w+([!#$%&‘*+–/=?^`.{|}~]?\w+)*@\w+([.-]?\w+)*(\.\w{1,4})+$/
			const phoneRegex = /^[-+]?[0-9]+$/
			let phoneNumber = '',
				email = '',
				username = '',
				isError = false,
				data = {}

			if (emailRegex.test(user.userId)) {
				email = user.userId
				data = {
					email: email
				}
			} else if (phoneRegex.test(user.userId)) {
				phoneNumber = user.userId
				data = {
					phone_number: phoneNumber
				}
			}
			else {
				username = user.userId
				data = {
					username: username
				}
			}

			if (isError) {
				reject("")
			}

			data.password = user.password

			resolve(data)

		})
	},

	checkUser({ commit }, user) {
		return new Promise((resolve, reject) => {
			/*eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/
			const { password, ...data } = user

			axios({
				method: 'POST',
				url: process.env.VUE_APP_BACKEND_URL + '/user/check_user',
				data: data
			})
				.then(response => {


					resolve(response.data.data.body)
				})
				.catch(error => {

					if (error.data) {
						if (error.data.status_code == 2018 || error.data.status_code == 2023 || error.data.status_code == 2022) {
							commit('AUTH_ERROR', 'ENSURE YOUR EMAIL AND PASSWORD ARE CORRECT')
						} else {
							commit('AUTH_ERROR', error.data.err_message)
						}
					}
					else if (error.response) {
						if (error.response.data.data) {
							commit('AUTH_ERROR', error.response.data.data.err_message)
						} else {
							/*
							 * The request was made and the server responded with a
							 * status code that falls out of the range of 2xx
							 */
							commit('AUTH_ERROR', error.response.data.message)

							if (error.response.data.status == 404 && error.response.data.message == 'Account not found!' || error.response.data.status == 422) {
								commit('AUTH_ERROR', 'ENSURE YOUR EMAIL AND PASSWORD ARE CORRECT')
							}
						}

						console.log(error.response.data)
						console.log(error.response.status)
						console.log(error.response.headers)
					} else if (error.request) {
						/*
						 * The request was made but no response was received, `error.request`
						 * is an instance of XMLHttpRequest in the browser and an instance
						 * of http.ClientRequest in Node.js
						 */
						commit('AUTH_ERROR', 'Server appears to be offline')
						console.log(error.request)
					} else {
						// Something happened in setting up the request and triggered an Error
					}

					reject(error)
				})
		})
	},

	AUTH_REQUEST({ commit, state, dispatch }, payload) {
		return new Promise((resolve, reject) => {
			dispatch('sha256', payload[1].password)
				.then((hashedPassword) => {
					if (payload[0]) {
						Vue.set(payload[1], 'password', hashedPassword)
					}

					window.grecaptcha.enterprise.ready(() => {
						window.grecaptcha.enterprise.execute(state.captchaSiteKey, {
							action: 'LOGINTRADING'
						})
							.then((token) => {
								axios({
									method: 'POST',
									url: process.env.VUE_APP_BACKEND_URL + '/user/auth',
									data: {
										...payload[1],
										clientCaptchaKey: token,
									},
									headers: {
										'Latitude': state.geolocation.latitude,
										'Longitude': state.geolocation.longitude,
										'City': state.geolocation.city,
										'Region': state.geolocation.region,
										'Country': state.geolocation.country,
										'IP-Address': state.geolocation.userIP,
									}
								})
									.then(response => {
										if (response.data.iserror == true) {
											throw ({ data: response.data.data })
										}

										const res = response.data.data

										// for login expired in frontend only
										localStorage.setItem('loginExpiredTime', Date.now() + state.loginExpiredTimeState)

										// for refresh token
										// localStorage.setItem('refreshTokenTime', Date.now() + state.refreshTokenTimeState)

										commit('AUTH_SUCCESS', res)

										console.log('berhasil login', response)
										resolve({
											name: res.fullname,
											email: res.email,
											phone: res.phone_number
										})
									})
									.catch(error => {
										dispatch('itemsToRemove')

										if (error.data) {
											if (error.data.status_code == 2018 || error.data.status_code == 2023) {
												commit('AUTH_ERROR', 'ENSURE YOUR EMAIL AND PASSWORD ARE CORRECT')
											} else {
												commit('AUTH_ERROR', error.message)
											}
										}
										else if (error.response) {
											/*
											 * The request was made and the server responded with a
											 * status code that falls out of the range of 2xx
											 */
											commit('AUTH_ERROR', error.response.data.data.err_message)

											if (error.response.data.status == 404 && error.response.data.message == 'Account not found!' || error.response.data.status == 422) {
												commit('AUTH_ERROR', 'ENSURE YOUR EMAIL AND PASSWORD ARE CORRECT')
											}

											console.log(error.response.data)
											console.log(error.response.status)
											console.log(error.response.headers)
										} else if (error.request) {
											/*
											 * The request was made but no response was received, `error.request`
											 * is an instance of XMLHttpRequest in the browser and an instance
											 * of http.ClientRequest in Node.js
											 */
											commit('AUTH_ERROR', 'Server appears to be offline')
											console.log(error.request)
										} else {
											// Something happened in setting up the request and triggered an Error
											console.log(error.message)
										}
										console.log('gagal login', error.config)
										reject(error)
									})
							})
					})
				})
		})

	},

	AUTH_LOGOUT(context) {
		return new Promise((resolve) => {
			let itemsToRemove = ['token', 'account', 'kinesisCookieSession', 'loginExpiredTime']
			context.commit('AUTH_LOGOUT', itemsToRemove)

			context.dispatch('itemsToRemove')

			// remove the axios default header
			delete axios.defaults.headers.common['Authorization']
			resolve()
		})
	},

	setTokenDemo(context, user) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'POST',
				url: process.env.VUE_APP_BACKEND_URL + '/demo-abx/account/create',
				data: {
					name: user.name,
					email: user.email,
					phone: user.phone,
				}
			}).then(response => {
				let demoData = response.data.data

				context.commit('SET_DEMO_ACCOUNT_ID', demoData)

				context.commit('SET_TOKEN', demoData.sessionKey)

				axios.defaults.headers.common['Authorization'] = 'Bearer ' + demoData.sessionKey

				console.log('berhasil register demo', response)
				resolve(response)
			}).catch(error => {
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}

				console.log('gagal register demo', error.config)
				reject(error)
			})
		})
	},

	itemsToRemove() {
		let itemsToRemove = ['token', 'loginExpiredTime', 'depths', 'gold', 'account', 'products', 'demoToken', 'demoAccountId', 'refreshTokenTime', 'geolocation', 'app', 'appName']
		itemsToRemove.forEach(item => localStorage.removeItem(item))
	},

	// setBalance(context) {
	// 	context.commit('CHANGE_SET_BALANCE_STATUS', 'loading')
	// 	if (context.getters.getAccountLevel == 'ib' || context.getters.getAccountLevel == 'fm') {
	// 		axios({
	// 			method: 'get',
	// 			url: process.env.VUE_APP_BACKEND_URL + '/rrs/total_balance_history'
	// 		}).then(response => {
	// 			let deposit = response.data.data
	// 			context.commit('CHANGE_SET_BALANCE_STATUS', 'idle')
	// 			context.commit('SET_BALANCE', {
	// 				balanceIdr: Number(Number(deposit.tot_bal_usd * context.getters.getStreamingRate.streamBuy).toFixed(2)),
	// 				balanceUsd: Number(Number(deposit.tot_bal_usd).toFixed(2)),
	// 				availableTradeBalanceIdr: Number(Number(deposit.tot_avail_bal * context.getters.getStreamingRate.streamBuy).toFixed(2)),
	// 				availableTradeBalanceUsd: Number(Number(deposit.tot_avail_bal).toFixed(2)),
	// 				accountBalance: Number(Number(deposit.tot_bal_usd).toFixed(2)),
	// 				reservedBalance: Number(Number(deposit.tot_reserved_bal).toFixed(2))
	// 			})
	// 		}).catch(error => {
	// 			context.commit('CHANGE_SET_BALANCE_STATUS', 'idle')
	// 			if (error.response) {
	// 				/*
	// 				 * The request was made and the server responded with a
	// 				 * status code that falls out of the range of 2xx
	// 				 */
	// 				console.log(error.response.data)
	// 				console.log(error.response.status)
	// 				console.log(error.response.headers)
	// 			} else if (error.request) {
	// 				/*
	// 				 * The request was made but no response was received, `error.request`
	// 				 * is an instance of XMLHttpRequest in the browser and an instance
	// 				 * of http.ClientRequest in Node.js
	// 				 */
	// 				console.log(error.request)
	// 			} else {
	// 				// Something happened in setting up the request and triggered an Error
	// 				console.log(error.message)
	// 			}
	// 		})
	// 	} else {
	// 		axios.post('/demo-abx/account/balanceHistory?marketplaceId=1&accountId=' + context.state.demoAccountId, {
	// 		}).then(response => {
	// 			let userBalance = response.data.data.data[0]
	// 			context.commit('CHANGE_SET_BALANCE_STATUS', 'idle')
	// 			context.commit('SET_BALANCE', {
	// 				balanceIdr: Number((userBalance.attributes.total * context.getters.getStreamingRate.streamBuy).toFixed(2)),
	// 				balanceUsd: Number(userBalance.attributes.total.toFixed(2)),
	// 				availableTradeBalanceIdr: Number((userBalance.attributes.total * context.getters.getStreamingRate.streamBuy).toFixed(2)),
	// 				availableTradeBalanceUsd: Number(userBalance.attributes.total.toFixed(2)),
	// 				accountBalance: Number(userBalance.attributes.total.toFixed(2)),
	// 				reservedBalance: 0
	// 			})

	// 			console.log('berhasil balance', response)
	// 		}).catch(error => {
	// 			context.commit('CHANGE_SET_BALANCE_STATUS', 'idle')
	// 			if (error.response) {
	// 				/*
	// 				 * The request was made and the server responded with a
	// 				 * status code that falls out of the range of 2xx
	// 				 */
	// 				console.log(error.response.data)
	// 				console.log(error.response.status)
	// 				console.log(error.response.headers)
	// 			} else if (error.request) {
	// 				/*
	// 				 * The request was made but no response was received, `error.request`
	// 				 * is an instance of XMLHttpRequest in the browser and an instance
	// 				 * of http.ClientRequest in Node.js
	// 				 */
	// 				console.log(error.request)
	// 			} else {
	// 				// Something happened in setting up the request and triggered an Error
	// 				console.log(error.message)
	// 			}
	// 			console.log('gagal balance', error.config)
	// 		})
	// 	}
	// },

	setDeposit(context) {
		context.commit('CHANGE_SET_BALANCE_STATUS', 'loading')
		if (context.getters.getAccountLevel == 'ib' || context.getters.getAccountLevel == 'fm') {
			axios({
				method: 'get',
				url: process.env.VUE_APP_BACKEND_URL + '/rrs/total_balance_history'
			}).then(response => {
				context.commit('CHANGE_SET_BALANCE_STATUS', 'idle')
				let deposit = response.data.data
				let balance = {
					balanceIdr: deposit.tot_bal_idr,
					balanceUsd: deposit.tot_bal_usd
				}
				context.commit('SET_BALANCE_2', balance)

				console.log('berhasil req deposit', response)
				// location.reload()
			}).catch(error => {
				context.commit('CHANGE_SET_BALANCE_STATUS', 'idle')
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('gagal req deposit', error.config)
			})
		} else {
			axios({
				method: 'get',
				url: process.env.VUE_APP_BACKEND_URL + '/demo/account_balance_history?marketplaceId=1&accountId=' + context.state.demoAccountId,
				headers: {
					token: context.state.demoToken
				}
			}).then(response => {
				context.commit('CHANGE_SET_BALANCE_STATUS', 'idle')
				let deposit = response.data.data[0]
				let balance = {
					balanceIdr: Number((deposit.attributes.total * context.getters.getStreamingRate.streamBuy).toFixed(2)),
					balanceUsd: Number(deposit.attributes.total.toFixed(2))
				}
				context.commit('SET_BALANCE_2', balance)

				console.log('berhasil req deposit', response)
				// location.reload()
			}).catch(error => {
				context.commit('CHANGE_SET_BALANCE_STATUS', 'idle')
				if (error.response) {
					/*
					 * The request was made and the server responded with a
					 * status code that falls out of the range of 2xx
					 */
					console.log(error.response.data)
					console.log(error.response.status)
					console.log(error.response.headers)
				} else if (error.request) {
					/*
					 * The request was made but no response was received, `error.request`
					 * is an instance of XMLHttpRequest in the browser and an instance
					 * of http.ClientRequest in Node.js
					 */
					console.log(error.request)
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log(error.message)
				}
				console.log('gagal req deposit', error.config)
			})
		}
	},

	setToken(context, token) {
		context.commit('SET_TOKEN', token)
	},
	setUser(context, payload) {
		context.commit('SET_USER', payload)
	},
	setOrderInTradeTicket(context, contractId) {
		let suffix, method, dataBody
		if (contractId == '6') {
			suffix = '/abx/kinesis/get/orders'
			method = 'post'
			dataBody = {
				cookieSession: context.state.kinesisCookieSession
			}
		} else {
			suffix = '/abx/orders'
			method = 'get'
			dataBody = null
		}
		axios({
			method: method,
			url: process.env.VUE_APP_BACKEND_URL + suffix,
			data: dataBody
		}).then(response => {
			let orders = response.data.data
			let finalOrders = []
			orders.forEach((order) => {
				if (contractId == '6') {
					if (order.orderType == 'limit') {
						let date = order.createdAt
						finalOrders.push({
							price: order.limitPrice,
							direction: order.direction,
							date: date.substring(8, 10) + date.substring(5, 7) + date.substring(2, 4)
						})
					}
				} else {
					if (order.attributes.contractId == contractId) {
						let date = order.attributes.createdAt
						finalOrders.push({
							price: 0,
							direction: order.attributes.direction,
							date: date.substring(8, 10) + date.substring(5, 7) + date.substring(2, 4)
						})
					}
				}
			})
			context.commit('SETORDERINTRADETICKET', finalOrders)
			console.log('berhasil order for trade ticket', response)
		}).catch(error => {
			if (error.response) {
				/*
				 * The request was made and the server responded with a
				 * status code that falls out of the range of 2xx
				 */
				console.log(error.response.data)
				console.log(error.response.status)
				console.log(error.response.headers)
			} else if (error.request) {
				/*
				 * The request was made but no response was received, `error.request`
				 * is an instance of XMLHttpRequest in the browser and an instance
				 * of http.ClientRequest in Node.js
				 */
				console.log(error.request)
			} else {
				// Something happened in setting up the request and triggered an Error
				console.log(error.message)
			}
			console.log('gagal order for trade ticket', error.config)
		})
	},

	changeCurrency(context, currency) {
		context.commit('CHANGE_CURRENCY', currency)
		localStorage.setItem('currency', JSON.stringify(currency))
		// let nowCurrency = JSON.parse(localStorage.getItem('currency')) || 'usd'
		// if (nowCurrency == 'usd') {
		//	context.commit('CHANGE_CURRENCY', 'idr')
		//	localStorage.setItem('currency',	JSON.stringify('idr'))
		// }else {
		//	context.commit('CHANGE_CURRENCY', 'usd')
		//	localStorage.setItem('currency',	JSON.stringify('usd'))	
		// }
	},

	setCustomDepth(context) {
		const customContractIds = context.state.customContractIds
		const depths = JSON.parse(JSON.stringify(context.state.depths))

		if (Object.keys(depths).length === 0) {
			console.log('WETWETWET', depths)
			return
		}

		let customDepthsTemp = {}

		for (let customId in customContractIds) {
			const contractConfig = context.getters.contractConfigByCustomId(customId)

			let depthTemp = JSON.parse(JSON.stringify(depths[customContractIds[customId].contractId]))

			//Multiply with weightCorrection if there is any contract that need to be shown differently from the original weight :)
			for (let i = 0; i < depthTemp.buy.length; i++) {
				depthTemp.buy[i].price = Number(Decimal.mul(depthTemp.buy[i].price, contractConfig.weightCorrection))
				depthTemp.buy[i].quantity = Number(Decimal.div(depthTemp.buy[i].quantity, contractConfig.weightCorrection).toFixed(contractConfig.depthQuantityDecimalPlace, Decimal.ROUND_DOWN))
			}

			for (let i = 0; i < depthTemp.sell.length; i++) {
				depthTemp.sell[i].price = Number(Decimal.mul(depthTemp.sell[i].price, contractConfig.weightCorrection))
				depthTemp.sell[i].quantity = Number(Decimal.div(depthTemp.sell[i].quantity, contractConfig.weightCorrection).toFixed(contractConfig.depthQuantityDecimalPlace, Decimal.ROUND_DOWN))
			}

			customDepthsTemp[customId] = depthTemp
		}

		context.commit('setCustomDepth', customDepthsTemp)

		console.log('Berhasil setCustomDepth')
	},

	setGold(context) {
		const contractsConfig = context.state.customContractIds

		let goldTemp = {}

		for (let key in contractsConfig) {
			const customDepth = context.getters.customDepthByCustomId(key)
			const contractConfig = context.getters.contractConfigByCustomId(key)

			let caretDirection = 'down'
			let percentage = 0.0
			let sellPrice = new Decimal(-1)
			let buyPrice = new Decimal(-1)
			let contract = context.state.contracts.find(obj => obj.id == contractsConfig[key].contractId)
			let contractPriceBuy = 0
			let contractPriceSell = 0

			if (customDepth && contract.attributes.contractStatusId == 'active') {
				for (let i = customDepth.buy.length - 1; i >= 0; i--) {
					let buyProp = customDepth.buy[i]
					if (i == customDepth.buy.length - 1) { //iniltialize buyPrice
						buyPrice = new Decimal(buyProp.price)
					}
					if (buyPrice.greaterThanOrEqualTo(buyProp.price)) {
						buyPrice = new Decimal(buyProp.price)
					}
				}

				for (let i = customDepth.sell.length - 1; i >= 0; i--) {
					let sellProp = customDepth.sell[i]
					if (i == customDepth.sell.length - 1) { //iniltialize sellPrice
						sellPrice = new Decimal(sellProp.price)
					}
					if (sellPrice.lessThanOrEqualTo(sellProp.price)) {
						sellPrice = new Decimal(sellProp.price)
					}
				}

				contractPriceBuy = buyPrice
				contractPriceSell = sellPrice

				buyPrice = buyPrice.dividedBy(contractConfig.weightMultiplication).toNumber()
				sellPrice = sellPrice.dividedBy(contractConfig.weightMultiplication).toNumber()
			}


			goldTemp[key] = {
				id: contract.attributes.productId,
				contractId: contract.id,
				caretDirection: caretDirection,
				percentage: percentage,
				contractPriceBuy: Number(contractPriceBuy),
				contractPriceSell: Number(contractPriceSell),
				sell: Number(sellPrice),
				buy: Number(buyPrice),
			}
		}

		context.commit('setGold', goldTemp)
		console.log('Berhasil setGold')
	},

	changeTradingType(context, payload) {
		localStorage.setItem('tradingType', JSON.stringify(payload))
		context.commit('CHANGE_TRADING_TYPE', payload)
	},

	setHoldings(context) {
		// this.holdingsStatus = 'loading'
		axios({
			method: 'get',
			url: process.env.VUE_APP_BACKEND_URL + '/demo-abx/account/holding?accountId=' + context.state.demoAccountId,
		}).then(response => {
			let holdings = response.data.data
			const tempWeight = ['-', '100 gram', '10 oz', '1 kg', '10 kg', '0.01 gram', '1 gram']

			let contracts
			let counter = 0
			let time = setInterval(function () {
				contracts = context.state.contracts

				if (contracts) {
					clearInterval(time)

					holdings.forEach((holding, index) => {
						holdings[index].attributes.contractWeight = tempWeight[holding.attributes.contractId]
					})

					context.commit('SET_HOLDINGS', holdings)
					console.log('berhasil set holdings', contracts, holdings)
				} else if (counter++ == 1800) { //timeout after 3 minutes
					clearInterval(time)
				}
			}, 100)
		}).catch(error => {
			// this.holdingsStatus = 'idle'
			if (error.response) {
				/*
				 * The request was made and the server responded with a
				 * status code that falls out of the range of 2xx
				 */
				console.log(error.response.data)
				console.log(error.response.status)
				console.log(error.response.headers)
			} else if (error.request) {
				/*
				 * The request was made but no response was received, `error.request`
				 * is an instance of XMLHttpRequest in the browser and an instance
				 * of http.ClientRequest in Node.js
				 */
				console.log(error.request)
			} else {
				// Something happened in setting up the request and triggered an Error
				console.log(error.message)
			}
			console.log('Gagal holdings', error.config)
		})
	},

	//status
	changeMarketInquiryStatus(context, status) {
		context.commit('CHANGE_MARKET_INQUIRY_STATUS', status)
	},

	updateVideo({ commit }, data) {
		commit('updateDataVideo', data)
	},
}
